var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrafficCone = function SvgIconTrafficCone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.034 2h-.013a1.77 1.77 0 0 0-1.64 1.165l-.004.013-1.886 5.426a1 1 0 0 0-.048.137L3.79 19.25H2.25a1 1 0 1 0 0 2h19.5a1 1 0 1 0 0-2h-1.539L16.555 8.734a1 1 0 0 0-.044-.126l-1.888-5.431-.005-.013A1.77 1.77 0 0 0 12.978 2h-1.944M7.732 14l1.39-4h5.755l1.391 4zm-.696 2-1.13 3.25h12.188L16.964 16zm2.782-8h4.364l-1.39-4h-1.583z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTrafficCone;